import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment-timezone";

// Components
import BlackDiv from "../../utils/BlackDiv";
import BlackButton from "../../utils/BlackButton";

// CSS
import "../../../css/news-article.css";

// Util
import { showReviewLocation } from "../../../utils/reviews/reviewLocation";

class ReviewPreviewItem extends React.PureComponent {
	render() {
		const { translations, item, type } = this.props;
		const locationAvailable = !!item.organization_city || !!item.organization_province;

		return (
			<div className="event-listing-item--content">
				<h3>{item.organization_title}</h3>
				<h4>{item.sector_description}</h4>
				{locationAvailable && <h3>{showReviewLocation(item)}</h3>}
				<div className="article-date">
					<span>{translations.sections.reviews_listing.start_date_label}:</span>
					{!!item.site_visit_starts && (
						<span className="start-date">
						{moment(item.site_visit_starts).format("MMM DD, YYYY")}

						</span>
					)}
				</div>

				<div className="news-article-preview--btn-container">
					{type === "pending" && (
						<BlackButton disabled={true}>
							{translations.sections.reviews_listing.pending_label}
						</BlackButton>
					)}
					{type === "assigned" && (
						<BlackDiv>
							{translations.sections.reviews_listing.learn_more_label}
						</BlackDiv>
					)}
					{type === "signup" && (
						<BlackDiv>{translations.sections.reviews_listing.register_label}</BlackDiv>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations
	};
};

export default connect(mapStateToProps)(hocElement(ReviewPreviewItem));

function hocElement(Component) {
	function figureOutRender(item, reviewer, props) {
		// User is registered for this, but not approved
		if (reviewer.user.registrations.filter(reg => reg.review_id === item.id).length) {
			return (
				<div className="news-article-preview">
					<Component reviewer={reviewer} item={item} type={"pending"} {...props} />
				</div>
			);
		}
		// User is approved and able to view review
		else if (
			reviewer.user.on_site.filter(reg => reg.review_id === item.id).length ||
			reviewer.user.reading.filter(reg => reg.review_id === item.id).length
		) {
			return (
				<Link to={`/reviews/${item.id}`} className="news-article-preview">
					<Component reviewer={reviewer} item={item} type={"assigned"} {...props} />
				</Link>
			);
		}
		// User can still sign up for this review
		else {
			return (
				<button
					className="news-article-preview news-article-preview--clickable"
					onClick={() => props.registerHandler(item)}
				>
					<Component reviewer={reviewer} item={item} type={"signup"} {...props} />
				</button>
			);
		}
	}

	return function EnhancedComponent({ reviewer, item, ...props }) {
		return <React.Fragment>{figureOutRender(item, reviewer, props)}</React.Fragment>;
	};
}



// WEBPACK FOOTER //
// ./src/components/home/reviews/ReviewPreviewItem.js